import React from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import upperFirst from 'lodash/upperFirst';
import get from 'lodash/get';
import './Select.less';

const { Option } = Select;

const TSelect: React.FC<
  SelectProps<string | undefined> & {
    size?: 'small' | 'middle' | 'large';
    renderItem?: any;
    /** `false` by default */
    useDefaultWrapper?: boolean;
    options: Array<{
      key?: string;
      value?: any;
      extra?: string;
      title?: string;
    }>;
  }
> = ({
  size = 'middle',
  options,
  useDefaultWrapper = false,
  renderItem = (option) => upperFirst(get(option, 'key') as string),
  ...props
}) => {
  const classNames = [`t-select t-select-${size}`];

  const wrapperProp = !useDefaultWrapper
    ? { getPopupContainer: (trigger) => trigger.parentNode }
    : '';
  return (
    <div style={{ position: 'relative' }} className="t-select-container">
      <Select
        className={classNames.join(' ')}
        size={size}
        {...wrapperProp}
        {...props}
      >
        {(options || []).map((option) => {
          const value = get(option, 'value');
          const extra = get(option, 'extra');
          const disabled = get(option, 'disabled');
          const title = get(option, 'title', undefined);
          const label = get(option, 'label', undefined);
          return (
            <Option
              key={value}
              value={value}
              disabled={disabled}
              title={title}
              label={label}
            >
              {renderItem(option)}
              {extra && (
                <>
                  &nbsp;
                  <small title={extra}>{extra}</small>
                </>
              )}
            </Option>
          );
        })}
      </Select>
    </div>
  );
};

export default TSelect;
